import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogRef } from '@angular/cdk/dialog';

import { ApiDialogService } from 'src/app/services/api/api-cdialog.service';
import { ActionEnum } from './../../../models/generic';
import { SnackbarService } from './../../../services/snackbar.service';
import { Product } from './../produto.class';
import { ApiCommissionService } from 'src/app/services/api/api-commission.service';
import {
  IParametersCommission,
  ICommission,
  IProductCommission,
  IProduct,
  IProductValues
} from './../../../models/commission';
import { Commission } from './../comissao.class';
import { ProductTabEnum } from 'src/app/models/commission';
import {
  DialogTypeEnum,
  IDialogCommissionData,
  IDialogConfirm
} from 'src/app/models/dialog';
import { TabTypeEnum, ActionType } from 'src/app/models/generic';
import { ITab } from 'src/app/models/tabs';

@Component({
  selector: 'app-comissao-dialog',
  templateUrl: './comissao-dialog.component.html',
  styleUrls: ['./comissao-dialog.component.scss']
})
export class ComissaoDialogComponent implements OnInit {
  TabTypeEnum = TabTypeEnum;
  ProductType = ProductTabEnum;
  Action = ActionEnum;

  commissionCardId!: string;
  commission: ICommission = new Commission();
  type: ActionType;
  tabs: ITab[] = [];
  visibleTabs: ITab[] = [];
  currentTab!: number | string;
  parameters!: IParametersCommission;
  productsTabs: IProductCommission[] = [];
  productsSelect: IProductCommission[] = [];
  firstElement: number = 0;

  allTabs: ITab[] = [];
  productTab: ITab = { title: 'Produto', id: ProductTabEnum.Produto };
  newProductTab: ITab = {
    title: 'Adicionar produto',
    id: ProductTabEnum.NovoProduto,
    visible: true,
    open: true,
    icon: {
      url: 'assets/icons/plus-solid-icon.svg',
      color: 'black',
      width: '12px',
      height: '12px'
    }
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IDialogCommissionData,
    private _dialogRef: DialogRef<ComissaoDialogComponent>,
    private _commissionService: ApiCommissionService,
    private _snackbarService: SnackbarService,
    private _dialogService: ApiDialogService
  ) {
    this.parameters = data.template.parameters;
    this.productsTabs = [...this.parameters.ProductsName];
    this.productsSelect = [...this.parameters.ProductsName];
    this.type = data.type as ActionType;
    this.commissionCardId = data.template.commissionCardId;
    this.generateTabs();
  }

  ngOnInit(): void {
    if (this.type !== ActionEnum.Create) this.getCommission();
    else this.filterTabs();
  }

  generateTabs(): void {
    this.allTabs = this.parameters.ProductsName.map((product) => {
      return { title: product.Name, id: product.ProductId };
    });

    this.allTabs.unshift(this.productTab);
    this.allTabs.push(this.newProductTab);
  }

  getCommission(): void {
    this._commissionService.getCommission(this.commissionCardId).subscribe({
      next: (response) => {
        this.commission = response.Data;
        this.sortingCommissionByProducts();
        this.filterTabs();
      }
    });
  }

  sortingCommissionByProducts(): void {
    this.commission.ProductsComission.sort((a, b) => {
      return (
        this.parameters.ProductsName.findIndex(
          (prod) => prod.ProductId === a.ProductId
        ) -
        this.parameters.ProductsName.findIndex(
          (prod) => prod.ProductId === b.ProductId
        )
      );
    });
  }

  filterTabs(): void {
    switch (this.type) {
      case ActionEnum.Create:
        this.filterCreationDialogTabs();
        break;
      case ActionEnum.Edit:
        this.filterEditDialogTabs();
        break;
      case ActionEnum.View:
        this.filterViewDialogTabs();
        break;
    }

    this.syncVisibleTabs();
    this.currentTab = this.tabs[this.firstElement].id as string;
    setTimeout(() => {
      this._commissionService.changeProductTabs.next(this.currentTab as string);
    }, 0);
  }

  filterCreationDialogTabs(): void {
    this.tabs = this.allTabs.filter(
      (tab) =>
        tab.id === ProductTabEnum.Produto ||
        tab.id === ProductTabEnum.NovoProduto
    );

    this.removeDuplicateProducts();
  }

  filterEditDialogTabs(): void {
    this.tabs = this.allTabs.filter((tab) => {
      return this.commission.ProductsComission.some(
        (product) => product.ProductId === tab.id
      );
    });

    this.tabs.forEach((tab, index) => {
      if (index > 0)
        tab.icon = {
          url: 'assets/icons/close-icon.svg',
          color: '',
          height: '17px',
          width: '17px',
          class: 'close-top',
          action: true
        };
    });

    if (this.tabs.length < this.parameters.ProductsName.length)
      this.tabs.push(this.newProductTab);

    this.removeDuplicateProducts();
  }

  filterViewDialogTabs(): void {
    this.tabs = this.allTabs.filter((tab) => {
      return this.commission.ProductsComission.some(
        (product) => product.ProductId === tab.id
      );
    });
  }

  changeTabs(tab: number | string): void {
    this.currentTab = tab;

    if (tab !== ProductTabEnum.NovoProduto) {
      this._commissionService.changeProductTabs.next(this.currentTab as string);
    }
  }

  syncVisibleTabs(): void {
    this.visibleTabs = [...this.tabs];
  }

  closeDialogCommission(): void {
    this._dialogRef.close();
  }

  changesProductValue(productId: string): void {
    this.renameFirstTab(productId);
    this.handlerProduct(productId);
    this.currentTab = productId;
    this.removeDuplicateProducts();
    this._commissionService.changeProductTabs.next(this.currentTab as string);
  }

  renameFirstTab(productId: string): void {
    let product = this.productsTabs.find(
      (prod) => prod.ProductId === productId
    ) as IProductCommission;

    if (product) {
      this.tabs[this.firstElement] = {
        title: product.Name,
        id: product.ProductId
      };
    }
  }

  handlerProduct(productId: string): void {
    this.commission.ProductsComission[this.firstElement].ProductId = productId;
  }

  removeDuplicateProducts(): void {
    this.productsTabs = this.parameters.ProductsName.filter((product) => {
      return !this.tabs.some((tab) => tab.id === product.ProductId);
    });

    this.productsSelect = this.parameters.ProductsName.filter((product) => {
      return (
        !this.tabs.some((tab) => tab.id === product.ProductId) ||
        product.ProductId ===
        this.commission.ProductsComission[this.firstElement].ProductId
      );
    });
  }

  insertProduct(product: IProductCommission): void {
    let firstProduct: IProduct =
      this.commission.ProductsComission[this.firstElement];

    const newProduct: IProduct = new Product(
      product.ProductId,
      firstProduct.ComissionId,
      firstProduct.BankId,
      firstProduct.CompanyId,
      firstProduct.Period,
      2, //firstProduct.CommissionType,
      0  //firstProduct.MaxCommissionPerContract
    );
    this.commission.ProductsComission.push(newProduct);
    this.currentTab = product.ProductId;
    this.insertProductTab(product);
    this.removeDuplicateProducts();
    this.syncVisibleTabs();
    this._commissionService.changeProductTabs.next(this.currentTab as string);
  }

  insertProductTab(product: IProductCommission): void {
    const productTab: ITab = {
      title: product.Name,
      id: product.ProductId,
      icon: {
        url: 'assets/icons/close-icon.svg',
        color: '',
        height: '17px',
        width: '17px',
        class: 'close-top',
        action: true
      }
    };

    if (this.isLastProductTab()) {
      this.tabs.pop();
      this.tabs.push(productTab);
    } else {
      let index: number = this.tabs.length - 1;
      this.tabs.splice(index, 0, productTab);
    }
  }

  isLastProductTab(): boolean {
    return this.tabs.length >= 6;
  }

  getformValue(product: IProduct): void {
    let index: number = this.commission.ProductsComission.findIndex(
      (prod) => prod.ProductId === product.ProductId
    );

    if (index >= 0 && product.BankId && product.CompanyId) {
      this.commission.ProductsComission[index] = product;
      this.convertStringToNumberProductions();
    }
  }

  convertStringToNumberProductions(): void {
    this.commission.ProductsComission.forEach((product) => {
      product.Productions.forEach((production) => {
        production.InitialProduction = Number(production.InitialProduction);
        production.FinalProduction = Number(production.FinalProduction);
        production.InvoiceValue = Number(production.InvoiceValue);
        production.Percentage = Number(production.Percentage);
        production.TransferValue = Number(production.TransferValue);
      });
    });
  }

  changesFormValue(productValues: IProductValues): void {
    if (this.commission.ProductsComission.length > 1) {
      this.commission.ProductsComission.forEach((product, index) => {
        if (index > 0) {
          product.BankId = productValues.BankId;
          product.CompanyId = productValues.CompanyId;
          product.Period = productValues.Period;
        }
      });
    }
  }

  handlerSaveCommission(): void {
    let dialogData = this.dataDialogConfirmation;

    this._dialogService.openDialog(dialogData).then((response) => {
      if (response) {
        this.removeEmptyIds();

        if (this.validationCommission()) {
          switch (this.type) {
            case ActionEnum.Create:
              this.createCommission();
              break;
            case ActionEnum.Edit:
              this.editCommission();
              break;
          }
        }
      }
    });
  }

  get dataDialogConfirmation(): IDialogConfirm {
    let text: string =
      this.type === ActionEnum.Create
        ? 'Tem certeza que deseja criar nova Comissão?'
        : 'Tem certeza que deseja editar a Comissão?';

    const dialogData: IDialogConfirm = {
      type: DialogTypeEnum.Optional,
      appearance: 'modern',
      template: {
        boldTitle: this.type === ActionEnum.Create ? 'Criar comissão' : 'Editar comissão',
        title: text,
        confirm: 'Sim',
        dismiss: 'Não'
      }
    };

    return dialogData;
  }

  validationCommission(): boolean {
    let bankId: string = this.commission.ProductsComission[this.firstElement].BankId;
    let companyId: string = this.commission.ProductsComission[this.firstElement].CompanyId;
    let productId: string = this.commission.ProductsComission[this.firstElement].ProductId;
    let period: string = this.commission.ProductsComission[this.firstElement].Period;

    // Se não tiver barra, insere
    if (!period.includes('/') && period.length === 6) {
      period = period.substring(0, 2) + '/' + period.substring(2);

      this.commission.ProductsComission.forEach((productsComission) => {
        productsComission.Period = period;
      });
    }

    // Regex para mm/yyyy (mm de 01 a 12, yyyy com 4 dígitos)
    const periodRegex = /^(0[1-9]|1[0-2])\/\d{4}$/;

    if (!bankId || !companyId || !productId || !period) {
      this._snackbarService.openSnackBar(
        'Preencha todos os campos obrigatórios.',
        'danger'
      );
      return false;
    }

    if (!periodRegex.test(period)) {
      this._snackbarService.openSnackBar(
        'Período inválido. Use o formato mm/aaaa.',
        'danger'
      );
      return false;
    }

    return true;
  }

  createCommission(): void {
    this._commissionService.createCommission(this.commission).subscribe({
      next: (response) => {
        this._snackbarService.openSnackBar(
          'Comissão criada com sucesso!',
          'success'
        );

        this._commissionService.listCommissionsEvent.next(true);
        this._dialogRef.close();
      }
    });
  }

  editCommission(): void {
    this._commissionService.updateCommission(this.commission).subscribe({
      next: (response) => {
        this._snackbarService.openSnackBar(
          'Comissão editada com sucesso!',
          'success'
        );

        this._commissionService.listCommissionsEvent.next(true);
        this._dialogRef.close();
      }
    });
  }

  deleteProductByTab(tabId: string): void {
    let indexProduct = this.commission.ProductsComission.findIndex(
      (product) => product.ProductId === tabId
    );

    let indexTab = this.tabs.findIndex((tab) => tab.id === tabId);

    if (indexProduct >= 0 && indexTab >= 0) {
      this.tabs.splice(indexProduct, 1);
      this.commission.ProductsComission.splice(indexProduct, 1);
      this.syncVisibleTabs();
      this.currentTab = this.tabs[this.firstElement].id as string;
      this.checkAndInsertNewProductsTab();
      this.insertTabRemovedInProducts(tabId);
    }
  }

  checkAndInsertNewProductsTab(): void {
    if (!this.tabs.some((tab) => tab.id === this.newProductTab.id))
      this.tabs.push(this.newProductTab);
  }

  insertTabRemovedInProducts(productId: string): void {
    let product = this.parameters.ProductsName.find(
      (prod) => prod.ProductId === productId
    ) as IProductCommission;

    if (product) {
      this.productsTabs.push(product);
      this.productsSelect.push(product);
    }
  }

  removeEmptyIds(): void {
    if (!this.commission?.ComissionId) delete this.commission.ComissionId;

    this.commission.ProductsComission.forEach((product) => {
      if (!product?.ComissionId) delete product.ComissionId;
      if (!product?.ProductComissionId) delete product.ProductComissionId;

      product.Productions.forEach((production) => {

        if (!production?.ProductionID) delete production.ProductionID;

        if (product.CommissionType === 1) {
          delete production.Percentage;
        } else {
          delete production.InvoiceValue;
          delete production.TransferValue;
        }
      });
    });
  }
}
